export default "__VITE_ASSET__eRpdueBa__"